import React, { useContext } from 'react'
import { useReactFlow } from '@xyflow/react';
import { Grid } from '@mui/material';

import styles from './../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss';

import { contentNodes } from './flowBuilderConstants';
import { contentNodesInterface } from '../../../models/flowBuilderTypes';
import { WorkflowContext, WorkflowContextPayload } from '../../../context/workflowContext';

function FlowBuilderNewNodeList(props: any) {
    
    const { nodesRef, addNode } = props
    const { screenToFlowPosition } = useReactFlow(); 

    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload;


    const handleAddNewNode = (node: contentNodesInterface) => {
        const screenCenter = {
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
        };
        const positionInFlow = screenToFlowPosition(screenCenter);
        const newCordinates = {
            x: positionInFlow.x + 50,
            y: positionInFlow.y + 50,
        }
        addNode(node, nodesRef, false, newCordinates); 
    }

    return (
        <Grid container padding={"20px"} direction={"column"} gap={"30px"} className={styles.nodesListsItems}>
            <Grid item sx={{ width: "100%" }}>
                <Grid container direction={"column"} gap={"16px"}>
                    <Grid item className={styles.nodesListHeadingStyle}>
                        Content
                    </Grid>
                    
                    <Grid item>
                        <Grid container gap={2}>
                            {contentNodes(currentActiveStaticWorkflow)?.map((node: contentNodesInterface) => {
                                return <Grid item
                                    onClick={() => handleAddNewNode(node)}
                                    className={`${styles.nodesGlobalItem} ${styles.messageNodeStyle}`}
                                    sx={{ ':hover': { background: node.style.hover }, border: node.style.border }}
                                >
                                    <Grid container direction={"column"} gap={"7px"} display={"flex"} justifyContent={"center"} alignItems={"center"} sx={{ textAlign: 'center', height: "100%" }}>
                                        {node.icon}
                                        <Grid item className={styles.nodeNameStyle}>{node.name}</Grid>
                                    </Grid>
                                </Grid>
                            })}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default FlowBuilderNewNodeList